module.exports = __webpack_public_path__ + "img/background11.9103b016.jpg";